export default "__VITE_ASSET__CExyTt9a__"